(() => {
  const setup = root => {
    root.querySelectorAll('[data-pp-sticky]').forEach(bar => {
      if(bar.dataset.bound) return;
      bar.dataset.bound = 'true';
      const info = bar.closest('product-info');
      if(!info) return;
      const mainButton = () => info.querySelector('button.product-form__submit');
      const sync = () => {
        const button = mainButton();
        if(!button) return;
        const rect = button.getBoundingClientRect();
        bar.hidden = rect.bottom > 0 && rect.top < window.innerHeight;
        const target = bar.querySelector('[data-pp-sticky-submit]');
        target.disabled = button.disabled || button.getAttribute('aria-disabled') === 'true';
        target.textContent = button.querySelector('span')?.textContent.trim() || button.textContent.trim();
        const price = info.querySelector('[id^="price-"] .price-item--sale') || info.querySelector('[id^="price-"] .price-item--regular');
        if(price) bar.querySelector('.pp-sticky-price').textContent = price.textContent.trim();
        const id = info.querySelector('form[action*="/cart/add"] input[name="id"]')?.value;
        const select=bar.querySelector('select');
        if(select && id) select.value = id;
      };
      bar.querySelector('[data-pp-sticky-submit]').addEventListener('click',()=>mainButton()?.click());
      bar.querySelector('select')?.addEventListener('change',event=>{
        const options=JSON.parse(event.target.selectedOptions[0].dataset.options);
        const picker=info.querySelector('variant-selects');
        if(!picker) return;
        const groups=picker.querySelectorAll('fieldset, .product-form__input--dropdown');
        let last;
        groups.forEach((group,index)=>{
          const radio=Array.from(group.querySelectorAll('input[type="radio"]')).find(el=>el.value===options[index]);
          if(radio){radio.checked=true;last=radio;}
          const select=group.querySelector('select');
          if(select){select.value=options[index];last=select;}
        });
        if(last)last.dispatchEvent(new Event('change',{bubbles:true}));
      });
      let scheduled=false;
      const schedule=()=>{if(scheduled)return;scheduled=true;requestAnimationFrame(()=>{scheduled=false;sync();});};
      const observer=new MutationObserver(mutations=>{if(mutations.some(m=>!bar.contains(m.target)))schedule();});
      observer.observe(info,{childList:true,subtree:true});
      info.addEventListener('change',schedule);
      window.addEventListener('scroll',schedule,{passive:true});
      window.addEventListener('resize',schedule);
      const intersection=new IntersectionObserver(schedule);
      if(mainButton())intersection.observe(mainButton());
      schedule();
    });
    root.querySelectorAll('[data-pp-video-toggle]').forEach(button=>{
      if(button.dataset.bound)return;button.dataset.bound='true';
      const video=button.closest('.pp-hero').querySelector('video');
      const refresh=()=>{button.textContent=video.paused?'▶':'Ⅱ';button.setAttribute('aria-label',video.paused?button.dataset.playLabel:button.dataset.pauseLabel);};
      button.addEventListener('click',()=>{if(video.paused)video.play().catch(()=>{});else video.pause();});
      video.addEventListener('play',refresh);video.addEventListener('pause',refresh);
      if(matchMedia('(prefers-reduced-motion: reduce)').matches)video.pause();refresh();
    });
  };
  document.addEventListener('input',event=>{const id=event.target.dataset.ppCompare;if(id)document.getElementById(id)?.style.setProperty('--pp-compare',event.target.value+'%');});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>setup(document));else setup(document);
  document.addEventListener('shopify:section:load',event=>setup(event.target));
})();
